import { Textarea } from '@mantine/core'
import styles from '../../styles/admin/StudyContent.module.scss'
import ImageDropzone from './ImageDropzone'

const ExplanationSection = ({
  explanation,
  onExplanationChange,
  explanationImageFile,
  onExplanationImageChange,
  existingImageUrl,
  onExistingImageRemove,
  placeholder = 'Write the explanation step by step.\n\nExample:\nStep 1: ...\nStep 2: ...',
  minRows = 12,
  showImage = true,
  className,
  label = 'Explanation',
}) => {
  return (
    <div className={styles.explanationSectionContainer}>
      <div className={styles.explanationSectionWrapper}>
        <div className={styles.explanationSectionHeader}>
          <span
            style={{
              fontSize: '15px',
              fontWeight: 700,
              color: '#111',
              marginLeft: '16px',
              marginBottom: '8px',
              display: 'block',
            }}
          >
            {label}
          </span>

          <Textarea
            value={explanation}
            onChange={(e) => onExplanationChange(e.target.value)}
            placeholder={placeholder}
            autosize
            minRows={minRows}
            classNames={{ input: styles.explanationTextarea }}
            style={{
              width: '100%',
              marginBottom: '16px',
              fontSize: '14px',
              lineHeight: 1.6,
              whiteSpace: 'pre-wrap',
            }}
          />
        </div>

        {showImage && (
          <div className={styles.explanationImageSection}>
            <ImageDropzone
              imageFile={explanationImageFile}
              onImageChange={onExplanationImageChange}
              existingImageUrl={existingImageUrl}
              iconSize={32}
              className={styles.imageDropzone}
              placeholderText="Drag & Drop or Click to Upload"
              showLabel={true}
              label="Explanation IMG"
              onExistingImageRemove={onExistingImageRemove}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ExplanationSection
